import {
	ECheckItemActionTypes,
	IShowCheckItemAction,
	ICloseCheckItemAction,
} from './../../types/redux/checkItem'

export const showCheckItem = (id: number, name: string = ''): IShowCheckItemAction => {
	return {
		type: ECheckItemActionTypes.SHOW_CHECK_ITEM,
		payload: { id, name },
	}
}

export const closeCheckItem = (): ICloseCheckItemAction => {
	return {
		type: ECheckItemActionTypes.CLOSE_CHECK_ITEM,
	}
}
